import React, {useEffect, useRef} from "react";
import "./AboutMe.css";
import {
  videoThumbnail,
  videoVideoMp4,
  videoVideoWebm,
} from "../../assets/videos";
import MagneticCircleButton from "../Buttons/MagneticCircleButton/MagneticCircleButton";
import Experiences from "../Experiences/Experiences";

const isTouchDevice = () => {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

const AboutMe = () => {
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    videoRef.current && videoRef.current.play();
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  useEffect(() => {
    if (!isTouchDevice() || !videoRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          videoRef.current.play().catch(() => {});
        } else {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
      },
      {
        threshold: 0.5,
      }
    );

    observer.observe(videoRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="about-me-section section">
        <div className="container about-me-container">
          <div className="about-me-container-wrapper">
            <div className="about-me-text-contents">
              <h2>
                Explore My
                <br />
                Experience
              </h2>

              <p>
                I’m Deep Kapadia, a frontend & full-stack developer with over 9+
                years of experience building fast, responsive, and user-focused
                web solutions.
              </p>

              <p>
                I believe great development goes beyond clean code — it’s about
                thoughtful architecture, intuitive user experiences, and solving
                real problems with scalable technology.
              </p>

              <p>
                With a detail-driven mindset and a passion for performance, I
                collaborate with startups, agencies, and entrepreneurs to turn
                ideas into impactful digital products. Let’s build something
                meaningful together.
              </p>

              <MagneticCircleButton
                text="Explore"
                text2="My Work"
                to="/projects"
              />
            </div>
            <div
              className="about-me-video-content"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <video
                loading="lazy"
                ref={videoRef}
                className="hover-video"
                poster={videoThumbnail}
                loop
                muted
                playsInline
              >
                <source src={videoVideoWebm} type="video/webm" />
                <source src={videoVideoMp4} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <Experiences />
        </div>
      </section>
    </>
  );
};

export default AboutMe;
